module.exports = new __parcel__URL__("16239_sq.32daf5e1.jpg").toString();